import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { fieldActions } from "data/objectApi"

import Card from "ui/components/Card"
import Table from "ui/components/Table"

import fieldTypes from "features/studio/utils/fieldTypes"
import DeleteFieldButton from "./DeleteFieldButton"

import Attribute from "features/records/components/Attribute"
import ConfigureFieldButton from "./ConfigureFieldButton"

const FieldTable = props => {
    const columns = [
        {
            accessor: "label",
            Header: "Label",
            Cell: cell => (
                <Attribute
                    onChange={value => {
                        props.fieldActions.update(cell.original._sid, { label: value })
                    }}
                    editable
                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "api_name",
            Header: "API Name",
            Cell: cell => (
                <Attribute
                    // onChange={value => {
                    //     props.fieldActions.update(cell.original._sid, { name: value })
                    // }}

                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },
        {
            accessor: "type",
            Header: "Type",
            Cell: cell => (
                <Attribute
                    field={{
                        type: "dropdown",
                        options: { options: fieldTypes },
                    }}
                    inline
                >
                    {cell.value}
                </Attribute>
            ),
        },

        {
            accessor: "type",
            Header: "",

            Cell: cell => {
                if (["dropdown", "lookup"].indexOf(cell.value) === -1) return ""
                return (
                    <ConfigureFieldButton
                        onChange={values => {
                            props.fieldActions.update(cell.original._sid, values)
                        }}
                        type={cell.value}
                        data={cell.original.options}
                    />
                )
            },
        },

        {
            accessor: "id",
            Header: "",
            width: 50,
            maxWidth: 50,
            Cell: cell => (
                <div className="hover" style={{ color: "#EEE", paddingTop: 10 }}>
                    <DeleteFieldButton
                        delete={() => props.fieldActions.remove(cell.original._sid)}
                    />
                </div>
            ),
        },

        // {
        //     accessor: "options.lookup_target",
        //     Header: "Linked To",
        //     Cell: cell => (
        //         <Attribute
        //             field={{
        //                 type: "lookup",
        //                 options: { lookup_target: "object" },
        //             }}
        //             inline
        //         >
        //             {cell.value}
        //         </Attribute>
        //     ),
        // },
    ]

    return (
        <Card>
            <Table columns={columns} data={props.data} />
        </Card>
    )
}

FieldTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
}

function mapDispatchToProps(dispatch) {
    return {
        fieldActions: bindActionCreators(fieldActions, dispatch),
    }
}

export default connect(
    () => {},
    mapDispatchToProps
)(FieldTable)



// WEBPACK FOOTER //
// ./src/features/studio/components/FieldTable.js